import { IError } from 'src/types/main';
import { cartStore } from '.';
import { localeStore } from '../localesStore';
import { messagesStore } from 'src/mobx/messagesStore';
import { isCashbackErrorCode } from 'src/utils/helpers';

export const CHECKOUT_HANDLERS = {
  MESSAGE: (message: string) => {
    cartStore.setModalValue(
      'error',
      cartStore.createError(localeStore.t(message), '', [
        {
          className: 'background-light',
          textClassName: 'color-dark',
          text: localeStore.t('Close'),
        },
      ])
    );
  },
  MESSAGE_EVENT: (error: IError) => cartStore.setModalValue('error', error),
  PREORDER: (message: string) => cartStore.setModalValue('preorder', { visible: true, message }),
};

export const RESPONSE_ERROR_HANDLER = (error: any) => {
  if (!error) return;

  const { data, message } = error;

  // cashback errors
  // if (isCashbackErrorCode(data.code) && cartStore.calculator.cashback.warning_code !== data.code) {
  //   cartStore.handleCashbackError(data.code, data.message);
  //   return;
  // }

  if (data.code === 10106 || data.code === 10101) {
    CHECKOUT_HANDLERS.MESSAGE_EVENT({
      title: data?.message || message,
      options: [
        {
          className: 'background-light',
          textClassName: 'color-dark',
          text: localeStore.t('Close'),
          onPress: () => {
            cartStore.closeCheckout();
          },
        },
      ],
    });
    return;
  }
  if (data.code === 10026) {
    CHECKOUT_HANDLERS.PREORDER(data?.message || 'busy_preorder');
    return;
  }
  if (data.message || message) {
    CHECKOUT_HANDLERS.MESSAGE(data?.message || message);
  }
};
